export default __webpack_public_path__ + "static/media/prima-logo.2eec3f54.svg";